import React from "react";
import {
  RazonFinancieraSubItem,
  RazonFinancieraSubItem2,
  RazonFinancieraSubItem3,
  RazonFinancieraSubItem4,
  RazonFinancieraSubItem4_1,
  RazonFinancieraSubItem4_2,
  RazonFinancieraSubItem4_3,
  RazonFinancieraSubItem4_4,
  RazonFinancieraSubItem2Completo,
  RazonFinancieraSubItem3Completo,
  RazonFinancieraSubItem4Completo,
  RazonFinancieraSubItem4Blanco,
  getColorClass,
} from "./RazonFinancieraSubItem";

export const RazonesFinancieraItem = ({ data, sucursales }) => {
  const GetIndicador = (valor, minino, medio) => {
    if (valor <= minino) return "flag-red";
    else if (valor <= medio) return "flag-yellow";
    else return "flag-green";
  };
  const factorAbsorcion = data?.razonesfinancieras?.find(item => item.razonfinanciera === 'Factor de absorcion')?.valor ?? 0;
  const rotacionActivos = data?.razonesfinancieras?.find(item => item.razonfinanciera === 'Rotacion de activos').valor ?? 0;
  const capitalActivos = data?.razonesfinancieras.find(item => item.razonfinanciera === 'Capital a activos').valor ?? 0;
  const coberturaIntereses = data?.razonesfinancieras?.find(item => item.razonfinanciera === 'Cobertura de intereses').valor ?? 0;
  const factorAbsorcionGuia = data?.razonesfinancieras?.find(item => item.razonfinanciera === 'Factor de absorcion')?.guia ?? 0;
  const rotacionActivosGuia = data?.razonesfinancieras?.find(item => item.razonfinanciera === 'Rotacion de activos').guia ?? 0;
  const capitalActivosGuia = data?.razonesfinancieras.find(item => item.razonfinanciera === 'Capital a activos').guia ?? 0;
  const coberturaInteresesGuia = data?.razonesfinancieras?.find(item => item.razonfinanciera === 'Cobertura de intereses').guia ?? 0;
  const factorAbsorcionIndicador = data?.razonesfinancieras?.find(item => item.razonfinanciera === 'Factor de absorcion')?.indicador ?? 0;
  const rotacionActivosIndicador = data?.razonesfinancieras?.find(item => item.razonfinanciera === 'Rotacion de activos').indicador ?? 0;
  const capitalActivosIndicador = data?.razonesfinancieras.find(item => item.razonfinanciera === 'Capital a activos').indicador ?? 0;
  const coberturaInteresesIndicador = data?.razonesfinancieras?.find(item => item.razonfinanciera === 'Cobertura de intereses').indicador ?? 0;
  const rotacioninventario = data?.rotacioninventario?.inventario ?? 0

  const getMedida = (indicador) => {
    if (indicador === "%") return "porcentaje";
    if (indicador === "x") return "numero-vueltas";
  };

  const convertGuiaNumero = (guia) => {
    if (!guia) return 0;
    const value = guia.replace(/[^\d\.x]/g, '');
    if (value.includes('x')) {
      return parseFloat(value.replace('x', ''));
    } else {
      return parseFloat(value);
    }
  };

  // console.log(rotacionActivosIndicador)
  // console.log (getMedida(rotacionActivosIndicador))

  return (
    <>
      <div className="dashboard-financiero-razones-financieras-proyecciones2">

        <RazonFinancieraSubItem4_1
          titulo="Factor de Absorción"
          valor={factorAbsorcion}
          guia={convertGuiaNumero(factorAbsorcionGuia)}
          medida={getMedida(factorAbsorcionIndicador)}
          modal={"FactorAbsorcion"}
          sucursales={sucursales}
        />
        <RazonFinancieraSubItem4_1
          titulo="Rotación de Activos"
          valor={rotacionActivos}
          guia={convertGuiaNumero(rotacionActivosGuia)}
          medida={getMedida(rotacionActivosIndicador)}
          modal={"RotacionInventario"}
        />
        <RazonFinancieraSubItem4_1
          titulo="Capital a Activos"
          valor={capitalActivos}
          guia={convertGuiaNumero(capitalActivosGuia)}
          medida={getMedida(capitalActivosIndicador)}
        // modal={"CapitalActivos"}
        />
        <RazonFinancieraSubItem4_2
          titulo="Cobertura de Intereses"
          valor={coberturaIntereses}
          guia={convertGuiaNumero(coberturaInteresesGuia)}
          medida={getMedida(coberturaInteresesIndicador)}
        // modal={"CoberturaIntereses"}
        />
        <RazonFinancieraSubItem4_1
          titulo="Rotación Inventario"
          valor={rotacioninventario}
          guia={0}
          medida={"numero-vueltas"}
          modal={"InventarioRotacionMainScreen"}
          sucursales={sucursales}
        />
      </div>

      {/* <div className="dashboard-financiero-razones-financieras-proyecciones2">
        <RazonFinancieraSubItem4_1
          titulo="Proyecciones Ventas"
          valor={0}
          guia={0}
          medida={"numero-vueltas"}
          modal={"ProyeccionesScreen"}
          sucursales={sucursales}
        />
        <RazonFinancieraSubItem4_1
          titulo="Proyecciones Gastos"
          valor={0}
          guia={0}
          medida={"numero-vueltas"}
          modal={"ProyeccionesGastosScreen"}
          sucursales={sucursales}
        />
      </div> */}
    </>
  );
};

export const RazonesFinancieraItem2 = () => {
  const GetIndicador = (valor, minino, medio) => {
    if (valor <= minino) return "flag-red";
    else if (valor <= medio) return "flag-yellow";
    else return "flag-green";
  };
  return (
    <div className="dashboard-financiero-razones-financieras2">

      <RazonFinancieraSubItem2Completo
        titulo="Rotación de Inventario"
        valor={1.3}
        guia={3}
        medida={"numero-vueltas"}
        modal={"RotacionInventario"}
      />
      <RazonFinancieraSubItem2Completo
        titulo="Rotación de Inventario"
        valor={2.1}
        guia={3}
        medida={"numero-vueltas"}
        modal={"RotacionInventario"}
      />
      <RazonFinancieraSubItem2Completo
        titulo="Rotación de Inventario"
        valor={2.9}
        guia={3}
        medida={"numero-vueltas"}
        modal={"RotacionInventario"}
      />
    </div>
  );
};

export const RazonesFinancieraItem3 = () => {
  const GetIndicador = (valor, minino, medio) => {
    if (valor <= minino) return "flag-red";
    else if (valor <= medio) return "flag-yellow";
    else return "flag-green";
  };
  return (
    <div className="dashboard-financiero-razones-financieras3">
      <RazonFinancieraSubItem3Completo
        titulo="Capital a Activos"
        valor={42.3}
        guia={50}
        medida={"porcentaje"}
        modal={"CapitalActivos"}
      />
      <RazonFinancieraSubItem3Completo
        titulo="Capital a Activos"
        valor={44.2}
        guia={50}
        medida={"porcentaje"}
        modal={"CapitalActivos"}
      />
      <RazonFinancieraSubItem3Completo
        titulo="Capital a Activos"
        valor={47.8}
        guia={50}
        medida={"porcentaje"}
        modal={"CapitalActivos"}
      />
    </div>
  );
};

export const RazonesFinancieraItem4 = () => {
  const GetIndicador = (valor, minino, medio) => {
    if (valor <= minino) return "flag-red";
    else if (valor <= medio) return "flag-yellow";
    else return "flag-green";
  };
  return (
    <div className="dashboard-financiero-razones-financieras4">

      <RazonFinancieraSubItem4Completo
        titulo="Cobertura de Intereses"
        valor={0.5}
        guia={2}
        medida={"numero-vueltas"}
        modal={"CoberturaIntereses"}
      />
      <RazonFinancieraSubItem4Completo
        titulo="Cobertura de Intereses"
        valor={1.3}
        guia={2}
        medida={"numero-vueltas"}
        modal={"CoberturaIntereses"}
      />
      <RazonFinancieraSubItem4Completo
        titulo="Cobertura de Intereses"
        valor={1.98}
        guia={2}
        medida={"numero-vueltas"}
        modal={"CoberturaIntereses"}
      />
    </div>
  );
};

